import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { InteractionStatus } from '../../../../../types/InteractionStatus';
import FormSubmitOrCancel from '../../../../molecules/Form/components/FormSubmitOrCancel/FormSubmitOrCancel';
import LiveRegion from '../../../../atoms/LiveRegion/LiveRegion';
import { FormUtils, useFormContext } from '../../../../molecules/Form';
import { CloseSecondaryView } from '../../BlockInteractionsTypes';
import { setPartOfStringBold } from '../../../../../lib/StringUtils/StringHTMLUtils';

type SubmitOrCancelFormTemplateType = {
  cancelAction: CloseSecondaryView;
  headline: string;
  headlineId: string;
  transnamespaceAndKey: string;
};

export function SubmitOrCancelFormTemplate({
  cancelAction,
  headline,
  headlineId,
  transnamespaceAndKey,
}: SubmitOrCancelFormTemplateType) {
  const { status, getStatus } = useFormContext();
  const { i18n, t } = useTranslation();

  const statusMessages = useMemo(() => {
    return {
      [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(
        setPartOfStringBold(t(`${transnamespaceAndKey}.status.success`), i18n, t)
      ),
      [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t(`${transnamespaceAndKey}.status.sending`)),
      [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t(`${transnamespaceAndKey}.status.fail`)),
    };
  }, [t, transnamespaceAndKey]);

  return (
    <>
      <FormSubmitOrCancel
        headline={headline}
        headlineId={headlineId}
        hierarchy={3}
        disableCancelButton={[InteractionStatus.SENDING, InteractionStatus.SUCCESS].includes(
          status as InteractionStatus
        )}
        disableSubmitButton={[InteractionStatus.SENDING, InteractionStatus.SUCCESS].includes(
          status as InteractionStatus
        )}
        cancelAction={cancelAction}
        hideSubmitButton={false}
      />
      <LiveRegion htmlTag="div" invisible={false}>
        {getStatus(statusMessages)}
      </LiveRegion>
    </>
  );
}
